import api from "./api";

// --- CRUD de Permissões ---
export function fetchPermissions() {
  return api.get("/permissions");
}

export function getPermissionById(id) {
  return api.get(`/permissions/${id}`);
}

export function createPermission(data) {
  return api.post("/permissions", data);
}

// CORRIGIDO: Agora aceita 'id' e 'data' e envia 'data' no corpo da requisição.
export function updatePermission(id, data) {
  return api.put(`/permissions/${id}`, data);
}

export function deletePermission(id) {
  return api.delete(`/permissions/${id}`);
}

export function deletePermissionsBatch(ids) {
  return api.delete("/permissions", {
    data: ids, // IDs no corpo da requisição para exclusão em lote
  });
}

export function fetchPermissionsPaged(pageNumber, pageSize, search = "") {
  return api.get("/permissions/paged", {
    params: {
      pageNumber,
      pageSize,
      search,
    },
  });
}
